import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';

const uploadConfig = [
  { type: 'contacts', label: 'Contactos', needsPeriod: false },
  { type: 'bank_accounts', label: 'Cuentas bancarias', needsPeriod: false },
  { type: 'invoices', label: 'Facturas', needsPeriod: true },
  { type: 'expenses', label: 'Gastos', needsPeriod: true },
];

const Imports = () => {
  const { activeTenant } = useTenant();
  const [batches, setBatches] = useState([]);
  const [files, setFiles] = useState({});
  const [periods, setPeriods] = useState({});

  const loadBatches = () => {
    if (!activeTenant) return;
    api.get(`/imports/batches?tenant_id=${activeTenant}`)
      .then((res) => setBatches(res.data || []))
      .catch(() => toast.error('Error al cargar importaciones'));
  };

  useEffect(() => {
    loadBatches();
  }, [activeTenant]);

  const handleUpload = async (type, needsPeriod) => {
    const file = files[type];
    if (!file) {
      toast.error('Selecciona un archivo');
      return;
    }
    if (needsPeriod && !periods[type]) {
      toast.error('Selecciona un periodo');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    if (needsPeriod) formData.append('period', periods[type]);
    try {
      await api.post(`/imports/${type}?tenant_id=${activeTenant}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Archivo subido');
      loadBatches();
    } catch (error) {
      toast.error('Error al subir archivo');
    }
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6" data-testid="client-imports-page">
      <div>
        <h1 className="text-4xl font-heading font-bold">Importaciones</h1>
        <p className="text-muted-foreground">Sube los archivos para validar y exportar.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {uploadConfig.map((cfg) => (
          <Card key={cfg.type}>
            <CardHeader>
              <CardTitle>{cfg.label}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              {cfg.needsPeriod && (
                <div>
                  <Label>Periodo</Label>
                  <Input
                    type="month"
                    value={periods[cfg.type] || ''}
                    onChange={(e) => setPeriods({ ...periods, [cfg.type]: e.target.value })}
                  />
                </div>
              )}
              <div>
                <Label>Archivo</Label>
                <Input type="file" onChange={(e) => setFiles({ ...files, [cfg.type]: e.target.files?.[0] })} />
              </div>
              <Button onClick={() => handleUpload(cfg.type, cfg.needsPeriod)}>Subir</Button>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Batches recientes</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {batches.length === 0 ? (
            <div className="px-6 py-6 text-sm text-muted-foreground">No hay importaciones.</div>
          ) : (
            batches.map((batch) => (
              <div key={batch.id} className="flex items-center justify-between px-6 py-4 border-b last:border-b-0">
                <div>
                  <div className="font-medium">{batch.type}</div>
                  <div className="text-xs text-muted-foreground">{batch.period || 'N/A'}</div>
                </div>
                <div className="text-xs text-muted-foreground">{batch.status}</div>
                <Link className="text-primary text-sm" to={`/client/imports/${batch.id}`}>
                  Ver detalle
                </Link>
              </div>
            ))
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Imports;
